import { render, staticRenderFns } from "./CardAssemblyResources.vue?vue&type=template&id=7001097c&scoped=true"
import script from "./CardAssemblyResources.vue?vue&type=script&lang=js"
export * from "./CardAssemblyResources.vue?vue&type=script&lang=js"
import style0 from "./CardAssemblyResources.vue?vue&type=style&index=0&id=7001097c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7001097c",
  null
  
)

export default component.exports